export default "__VITE_ASSET__5fe26bb2__"